const footerCols = [
  { title: "内容索引", links: ["来龙去脉速览", "全记录时间线", "阶段拆解", "疑点清单", "评论区氛围"] },
  { title: "阅读建议", links: ["先看阶段总览", "再对时间对应关系", "独立核对截图", "关注本站更新", "理性不站队"] },
  { title: "关于本站", links: ["本站定位", "信息来源说明", "纠错 / 补充线索", "内容政策", "联系整理者"] },
];

export default function Footer() {
  return (
    <>
      {/* 收尾 CTA 横幅 */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20minimal%20archive%20backdrop%20on%20warm%20paper%20texture%2C%20faint%20ruler%20grid%20and%20thin%20timeline%20lines%20with%20sparse%20vermilion%20and%20amber%20marker%20dots%2C%20large%20open%20negative%20space%20in%20center%2C%20soft%20editorial%20print%20finish%2C%20no%20text%2C%20no%20faces%2C%20abstract%20document%20archive%20concept&width=1600&height=700&seq=band51-x02&orientation=landscape"
            alt=""
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-100 via-background-50/80 to-background-50"></div>
        </div>

        <div className="relative mx-auto max-w-4xl px-4 py-16 text-center md:px-6 md:py-24">
          <span className="sec-kicker inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
            <span className="h-px w-8 bg-primary-400"></span>还没看够？<span className="h-px w-8 bg-primary-400"></span>
          </span>
          <h2 className="font-head-cn mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
            把这条完整始末收藏起来，
            <br />
            有新节点，第一时间在这里补录
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-7 text-foreground-700">
            从爆发到后续、从各阶段变化到时间对应关系，都在这一页替你收拢好。想看完整经过，从这里出发就对了。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#shijianxian"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-time-line"></i>回到全记录时间线
            </a>
            <a
              href="#top"
              className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50/80 px-6 py-3 text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
            >
              <i className="ri-arrow-up-line"></i>返回顶部
            </a>
          </div>
        </div>
      </section>

      {/* 页脚 */}
      <footer className="border-t border-background-200 bg-background-100">
        <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-5">
            <div className="md:col-span-2">
              <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-focus-3-line text-lg"></i>
                </span>
                <span className="font-head-cn text-lg font-bold tracking-tight text-foreground-950">
                  51<span className="text-primary-600">反差</span>
                </span>
              </a>
              <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-600">
                一站式收拢 51反差事件的来龙去脉与时间对应关系，面向想看完整经过与始末梳理的同学，做一条清晰可对的时间线。
              </p>
              <p className="mt-5 text-xs leading-5 text-foreground-500">
                本站内容为网络公开信息之整理归档，不构成对任何一方之定性；事实以官方与当事人说明为准。
              </p>
            </div>

            {footerCols.map((col) => (
              <nav key={col.title} className="flex flex-col">
                <h4 className="sec-kicker text-xs font-semibold text-foreground-700">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l}>
                      <a href="#shijianxian" className="text-sm text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>

          <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">© 2026 51反差 · 事件全记录时间线整理 · 完整始末与全程回顾追踪</p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1.5"><i className="ri-focus-3-line text-primary-600"></i>51反差 整理小组</span>
              <span className="inline-flex items-center gap-1.5"><i className="ri-file-list-3-line"></i>归档版 v3.2</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}